import React from 'react';
import PropTypes from 'prop-types';

import { TableHead as MUITableHead } from '@material-ui/core';

export const TableHead = props => <MUITableHead {...props} />;

TableHead.propTypes = {
  classes: PropTypes.object,
  component: PropTypes.elementType
};

export default TableHead;
